<template>
  <div class="position-ab">
    <template v-if="show">
      <!-- 未汇总 -->
      <!-- <template v-if="true"> -->
      <template v-if="summaryStaus == 0">
        <noSummary :type="1"></noSummary>
      </template>
      <!-- 汇总中 -->
      <!-- <template v-else-if="true"> -->
      <template v-else-if="summaryStaus == 1">
        <summaryingOrComplete :status="0" :type="1"></summaryingOrComplete>
      </template>
      <!-- 汇总完成 -->
      <template v-else-if="summaryStaus == 2">
        <summaryingOrComplete :status="1" :type="1"></summaryingOrComplete>
      </template>
    </template>
  </div>
</template>

<script>
import noSummary from "@/app/subSourcingFlow/views/expertEvaluate/components/noSummaryNew.vue";
import summaryingOrComplete from "@/app/subSourcingFlow/views/expertEvaluate/components/summaryingOrCompleteNew.vue";
import { scpQryBidEvaProcessStatusApi } from "@/app/sourcingFlow/api/scp-expertEvaluation.js";

export default {
  name: "subSummaryBusinessSkillsScores",
  components: {
    noSummary,
    summaryingOrComplete
  },
  data() {
    return {
      summaryStaus: Number(
        JSON.parse(sessionStorage.getItem("bidEvaProcessStatus")).billStatus
      ), // 0:未汇总 1：汇总中 2：汇总完成
      // type: 1 // 商务技术评分汇总
      show: false
    };
  },
  mounted() {
    scpQryBidEvaProcessStatusApi({
      schemeId: JSON.parse(sessionStorage.getItem("expertSourceData")).schemeId,
      joinExpertId: sessionStorage.getItem("joinId"),
      purStep: this.$router.history.current.query.menuKey,
      evaPurStep: this.$router.history.current.query.evaPurStep
    }).then(res => {
      this.$set(this, "summaryStaus", res.data.data.billStatus);
      this.show = true;
    });
  },
  methods: {}
};
</script>

<style lang="scss" scoped></style>
